module.exports = __webpack_public_path__ + "img/resource-tech-image-75.70a5123a.jpg";